module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackCond.7e6e932.woff";